import { SCREEN_PRESENTER } from '@shoflo/polymer';
import { createSource } from 'actions/source';

function createDirectorScreenShareSource() {
  return (dispatch, getState) => {
    const state = getState();
    const {
      meeting: { attendeeResponse },
      broadcastSources: { sources },
    } = state;

    const directorId = attendeeResponse && attendeeResponse.Attendee.AttendeeId;

    if (directorId) {
      const directorScreenShareAttendeeId = `${directorId}#content`;
      const directorScreenShareExists = sources.find(
        (source) => source.value === directorScreenShareAttendeeId
      );

      if (!directorScreenShareExists) {
        let title = `${directorId}`;
        const directorSource = sources.find(
          (source) => source.value === directorId
        );
        if (directorSource && directorSource.title) {
          title = directorSource.title;
        }
        dispatch(
          createSource({
            title,
            type: SCREEN_PRESENTER,
            value: directorScreenShareAttendeeId,
          })
        );
      }
    }
  };
}

export default createDirectorScreenShareSource;
